export const VIEW_DASHBOARD_INNI_CTA = "viewDashboardInniCTA";
export const DASHBOARD_INNI_PREVIEW_ID = "dashboard-inni-preview";

const SCROLL_RETRY_DELAY_MS = 100;
const SCROLL_RETRY_COUNT = 20;

export function requestScrollToInniPreviewView() {
  if (typeof window === "undefined") {
    return;
  }

  localStorage.setItem(VIEW_DASHBOARD_INNI_CTA, "true");
  scrollToInniPreviewView();
}

export function scrollToInniPreviewView(attempt = 0) {
  if (typeof window === "undefined") {
    return;
  }

  const element = document.getElementById(DASHBOARD_INNI_PREVIEW_ID);
  if (element) {
    element.scrollIntoView({ behavior: "smooth", block: "center" });
    localStorage.removeItem(VIEW_DASHBOARD_INNI_CTA);
    return;
  }

  if (attempt < SCROLL_RETRY_COUNT) {
    window.setTimeout(
      () => scrollToInniPreviewView(attempt + 1),
      SCROLL_RETRY_DELAY_MS
    );
  }
}
